import React from 'react';
import PropTypes from 'prop-types';
import { isParsedJson, parseSanitizedHtml } from '../../../util';
import MessageAttachment from '../MessageAttachment/MessageAttachment';
import { toFriendly as toFriendlyMessageStatus } from 'constants/messageStatuses';
import { isMessageSmbReply } from 'util/messageUtil';
import { v4 as uuidv4 } from 'uuid';
import { OUTBOUND } from 'constants/messageDirection';
import { getMessageAvatar } from 'util/avatarUtil';
import { SenderInDisplayComponent } from 'components/Widgets/SenderInDisplayComponent/SenderInDisplayComponent';
import MessageTimeMarker from '../MessageTimeMarker/MessageTimeMarker';
import MessageImages from '../MessageImages/MessageImages';
import TranslationInfo from 'components/Messages/TranslationInfo/TranslationInfo';
import { AvatarBox, Avatar } from 'components/common/avatar';
import {
  WhiteSpaceNormalizeWrapper,
  ShowHiddenContentComponent,
  Icon,
  TicketTextBoldBlue,
  TicketTextBoldGray,
  InlineBlockComponent,
  EmailMessageBox,
  HiddenContentButton,
  HiddenContentBox,
  HiddenContentText,
  MessageContent,
  EmailSentStatusMarker,
  MessageHeader,
  MessageBody,
  SMBReplyMessageBody,
} from './EmailMessage.styles';

class EmailMessageComponent extends React.Component {
  state = {
    showHiddenContent: false,
  };

  render() {
    const {
      message,
      messageBodyContent,
      messageClasses,
      parentTicketId,
      isAdmin,
      messageStatusColor,
      messageTime,
      messageOriginalTime,
      messageTimeDiffExists,
      simplrAccountId,
      language,
      translatedFrom,
    } = this.props;

    const { showHiddenContent } = this.state;

    let attachments;
    if (message.mediaUrl && isParsedJson(message.mediaUrl)) {
      attachments = message.mediaUrl.map((url) => {
        return <MessageAttachment src={url} key={url} />;
      });
    }

    return (
      <>
        <EmailMessageBox key={message.messageId} className={messageClasses.join(' ')}>
          <AvatarBox>
            <Avatar alt="message" src={getMessageAvatar(message, parentTicketId)} />
          </AvatarBox>
          <MessageBody>
            <MessageHeader>
              <InlineBlockComponent>
                <SenderInDisplayComponent isAdmin={isAdmin} message={message} />
                {isMessageSmbReply(message) && (
                  <SMBReplyMessageBody>NOTE: This ticket is still open. Please respond.</SMBReplyMessageBody>
                )}
              </InlineBlockComponent>
              <InlineBlockComponent>
                {message.direction === OUTBOUND && toFriendlyMessageStatus(message.status) && (
                  <EmailSentStatusMarker color={messageStatusColor}>
                    {toFriendlyMessageStatus(message.status)}
                  </EmailSentStatusMarker>
                )}
                <MessageTimeMarker
                  isAdmin={isAdmin}
                  messageDirection={message.direction}
                  messageReceivedTime={messageTime}
                  messageCreatedTime={messageOriginalTime}
                  messageTimeDiffExists={messageTimeDiffExists}
                />
              </InlineBlockComponent>
            </MessageHeader>
            {!!messageBodyContent && (
              <MessageContent>
                <WhiteSpaceNormalizeWrapper>{messageBodyContent}</WhiteSpaceNormalizeWrapper>
              </MessageContent>
            )}
            {attachments}
            <MessageImages
              message={message}
              isAdmin={isAdmin}
              avatarUrl={getMessageAvatar(message, parentTicketId)}
              messageOriginalTime={messageOriginalTime}
              simplrAccountId={simplrAccountId}
            />
          </MessageBody>
          {translatedFrom && <TranslationInfo from={translatedFrom} to={language} />}
        </EmailMessageBox>
        {message.hiddenContent && (
          <HiddenContentButton showHiddenContent={showHiddenContent}>
            <ShowHiddenContentComponent
              onClick={() => this.setState({ showHiddenContent: !this.state.showHiddenContent })}
            >
              {showHiddenContent ? (
                <>
                  <TicketTextBoldGray>Hide</TicketTextBoldGray>
                  <Icon>
                    <img alt="hide" src="/images/hidden-eye.svg" />
                  </Icon>
                </>
              ) : (
                <>
                  <TicketTextBoldBlue>Hidden Message</TicketTextBoldBlue>
                  <Icon>
                    <img alt="hide" src="/images/visible-eye.svg" />
                  </Icon>
                </>
              )}
            </ShowHiddenContentComponent>
          </HiddenContentButton>
        )}
        {showHiddenContent && (
          <HiddenContentBox key={uuidv4()} className={messageClasses.join(' ')}>
            <MessageBody>
              <MessageContent>
                <WhiteSpaceNormalizeWrapper>
                  <HiddenContentText {...parseSanitizedHtml(message.hiddenContent)} />
                </WhiteSpaceNormalizeWrapper>
              </MessageContent>
            </MessageBody>
          </HiddenContentBox>
        )}
      </>
    );
  }
}

export default EmailMessageComponent;

EmailMessageComponent.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  message: PropTypes.object.isRequired,
  messageClasses: PropTypes.array.isRequired,
  messageStatusColor: PropTypes.string.isRequired,
  messageTime: PropTypes.string.isRequired,
  parentTicketId: PropTypes.string.isRequired,
  simplrAccountId: PropTypes.string.isRequired,
};
